import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { getStoredRef, visitorId } from "@/lib/referral";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = unauth, object = user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data.user);
      } catch {
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const ref = getStoredRef();
    const { data } = await api.post("/auth/register", { ...payload, referral_code: ref?.code, visitor_id: visitorId() });
    if (ref) localStorage.setItem("csi_ref", JSON.stringify({ ...ref, attached: true }));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const impersonate = async (userId) => {
    const { data } = await api.post(`/admin/users/${userId}/impersonate`);
    setUser(data.user);
    return data.user;
  };

  const stopImpersonation = async () => {
    const { data } = await api.post("/auth/stop-impersonation");
    setUser(data.user);
    return data.user;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser, impersonate, stopImpersonation }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
